<template>
  <component :is="currentComponent" v-if="currentComponent" />
</template>

<script>
import Home from "./Home.vue";
import HomeNew from "./HomeNew.vue";
import { queryBydic } from "../../service/api/product";

const PAY_SYSTEM_CONF_DIC = "U-BIZ-PAYSYSTEMCONF";

export default {
  name: "HomeWrapper",
  data() {
    return {
      currentComponent: null,
    };
  },
  async created() {
    const inDict = await this.isMerchInPaySystemConf();
    // 字典未命中或查询失败，一律走旧首页
    this.currentComponent = inDict ? HomeNew : Home;
  },
  methods: {
    getCurrentMerchId() {
      try {
        const userInfo =
          JSON.parse(localStorage.getItem("userInfo") || "{}") || {};
        const merchId = userInfo.merchId;
        if (merchId == null || merchId === "") {
          return "";
        }
        return String(merchId);
      } catch (e) {
        return "";
      }
    },
    async isMerchInPaySystemConf() {
      const merchId = this.getCurrentMerchId();
      if (!merchId) {
        return false;
      }
      try {
        const result = await queryBydic(PAY_SYSTEM_CONF_DIC);
        const items = (result && result.data) || [];
        if (!Array.isArray(items)) {
          return false;
        }
        return items.some((item) => String(item && item.name) === merchId);
      } catch (e) {
        console.warn("支付系统字典查询失败，使用原有首页", e);
        return false;
      }
    },
  },
};
</script>
